import { createContext } from 'react';

export const AuthState = createContext();